// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-advanced-faculty-modal {
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  width: 100%;
}
.search-advanced-faculty-modal .search-bar {
  width: 100%;
  margin-right: 30px;
  height: 35px;
  display: flex;
  justify-content: space-between;
}
.search-advanced-faculty-modal .search-bar .ant-input-wrapper {
  height: 100%;
}
.search-advanced-faculty-modal .search-bar .advanced-search-button {
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  cursor: pointer;
  color: white;
  padding: 0 20px;
  border-radius: 10px;
}
.search-advanced-faculty-modal .search-bar .advanced-search-button p {
  white-space: nowrap;
}
.search-advanced-faculty-modal .advanced-search {
  margin-top: 10px;
}
.search-advanced-faculty-modal .sub-title-search-advance-modal {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px !important;
}
.search-advanced-faculty-modal .filters-search-modal {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}
.search-advanced-faculty-modal .filters-search-modal .group-filters {
  display: flex;
  margin-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/SearchAdvanceFacultyModal.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACF;AAAE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AAEJ;AADI;EACE,YAAA;AAGN;AADI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAGN;AAFM;EACE,mBAAA;AAIR;AAAE;EACE,gBAAA;AAEJ;AAAE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AAEJ;AAAE;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAEJ;AADI;EACE,aAAA;EACA,kBAAA;AAGN","sourcesContent":[".search-advanced-faculty-modal {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 40px;\n  width: 100%;\n  .search-bar {\n    width: 100%;\n    margin-right: 30px;\n    height: 35px;\n    display: flex;\n    justify-content: space-between;\n    .ant-input-wrapper {\n      height: 100%;\n    }\n    .advanced-search-button {\n      height: 35px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 600;\n      cursor: pointer;\n      color: white;\n      padding: 0 20px;\n      border-radius: 10px;\n      p {\n        white-space: nowrap;\n      }\n    }\n  }\n  .advanced-search {\n    margin-top: 10px;\n  }\n  .sub-title-search-advance-modal {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 5px !important;\n  }\n  .filters-search-modal {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 10px;\n    .group-filters {\n      display: flex;\n      margin-right: 20px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
